import { eventBus } from "../main";
let socket = null;

const event = new Event("message");

export default {
  connect(token) {
    // 1、 建立连接，使用token建立连接
    // console.log(token);
    const url = process.env.VUE_APP_API_BASE_URL
    // const url = "https://ai.yilianzh.com"
    // const url = "http://192.168.1.27:8888"
    // http、https转ws
    socket = new WebSocket(url.replace(/^http/, "ws") + "/api/websocket/" + token);
    // socket = new WebSocket(`ws://192.168.1.27:8888/api/websocket/` + token)  // 内网
    // socket = new WebSocket("ws://192.168.1.206:8888/api/websocket/" + token); // 侯海鹏
    // socket = new WebSocket("wss://ai.yilianzh.com/api/websocket/" + token); // 公网IP
    socket.onopen = () => {
      // 2、连接成功后，通过eventBus把消息传递出去
      console.log("WebSocket连接已打开");
      eventBus.$emit("websocket-opened");
    };
    socket.onmessage = (event) => { };
    socket.onclose = (event) => {
      if (event.code === 1000) {
        console.log("WebSocket连接被手动关闭");
      } else {
        console.log("WebSocket连接因为超时自动关闭,自动重新连接！");
        eventBus.$emit("websocket-close");
        // 尝试重新连接
        setTimeout(() => {
          this.connect(token); // 重新连接
        }, 500); // 
      }
    };
  },
  send(message) {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    } else {
      console.error("WebSocket连接未打开");
    }
  },
  close() {
    if (socket) {
      socket.close();
    }
  },

  // 监听服务器传过来的消息
  addEventListener(type, listener) {
    if (socket) {
      socket.addEventListener(type, listener);
    }
  },
};
